module.exports = __webpack_public_path__ + "img/18_32.efad8ba5.png";